// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WYKC","question":"styles_question__1-_D8","inputVisibleButton":"styles_inputVisibleButton__EjIrO","note":"styles_note__2z0QS"};